import {FuseNavigation} from '../../@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id: 'MENU',
        title: 'Menu',
        translate: 'NAV.MENU',
        type: 'group',
        icon: 'bar_chart',
        isActive: false,
        children: [

            {
                id: 'DASHBOARD',
                title: 'Dashboard',
                translate: 'NAV.DASHBOARDS',
                type: 'item',
                icon: 'dashboard',
                url: '/dashboard',
                isActive: false
            },
            {
                id: 'CHEMIST',
                title: 'Chemist',
                translate: 'NAV.CHEMIST',
                type: 'collapsable',
                icon: 'local_pharmacy',
                isActive: false,
                url: '/dashboard/chemist',
                children: [
                    {
                        id: '',
                        title: 'Chemist',
                        translate: 'NAV.CHEMIST',
                        type: 'collapsable',
                        icon: 'local_pharmacy',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_CHEMIST',
                                title: 'Chemist List',
                                type: 'item',
                                url: '/chemist/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Visit',
                        translate: 'NAV.CHEMIST',
                        type: 'collapsable',
                        icon: 'local_pharmacy',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_VISIT_FOR_CHEMIST',
                                title: 'Chemist Visit List',
                                type: 'item',
                                url: '/chemistVisit/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_CHEMIST_VISIT_TYPE',
                                title: 'Chemist Visit Type List',
                                type: 'item',
                                url: '/chemist-visit-type/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Chemist Settings',
                        translate: 'NAV.CHEMIST',
                        type: 'collapsable',
                        icon: 'local_pharmacy',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_CHEMIST_TYPE',
                                title: 'Chemist Type List',
                                type: 'item',
                                url: '/chemist-type/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_CHEMIST_APPROVAL_RULE',
                                title: 'Chemist Approval Rules',
                                type: 'item',
                                url: '/chemist-approval-rules/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    }
                ]
            },
            {
                id: 'DOCTOR',
                title: 'Doctor & Institute',
                translate: 'NAV.DOCTOR',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                url: '/dashboard/doctor',
                children: [
                    {
                        id: '',
                        title: 'Doctor',
                        translate: 'NAV.DOCTOR',
                        type: 'item',
                        icon: 'local_hospital',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_DOCTOR',
                                title: 'Doctor List',
                                type: 'item',
                                url: '/doctor/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Survey Doctor',
                        translate: 'NAV.DOCTOR',
                        type: 'item',
                        icon: 'local_hospital',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_SURVEY_DOCTOR',
                                title: 'Survey Doctor List',
                                type: 'item',
                                url: '/survey-doctor/list',
                                isActive: false
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Doctor Record',
                        translate: 'NAV.DOCTOR',
                        type: 'item',
                        icon: 'local_hospital',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_DOCTOR_RECORD',
                                title: 'Doctor Record List',
                                type: 'item',
                                url: '/doctor-record/list',
                                isActive: false
                            },
                            {
                                id: 'UPLOAD_DOCTOR_RECORD',
                                title: 'Doctor Record Upload',
                                type: 'item',
                                url: '/doctor-record/upload',
                                isActive: false
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Institute',
                        translate: 'NAV.DOCTOR',
                        type: 'item',
                        icon: 'local_hospital',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_INSTITUTE',
                                title: 'Institute List',
                                type: 'item',
                                url: '/institute/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_INSTITUTE_TYPE',
                                title: 'Institute Types',
                                type: 'item',
                                url: '/institute-type/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_INSTITUTE_DEPARTMENT',
                                title: 'Department List',
                                type: 'item',
                                url: '/department/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Doctor Settings',
                        translate: 'NAV.DOCTOR',
                        type: 'item',
                        icon: 'local_hospital',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_ACADEMIC_DEGREE',
                                title: 'Degree List',
                                type: 'item',
                                url: '/degree/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_DOCTOR_DESIGNATION',
                                title: 'Designation List',
                                type: 'item',
                                url: '/doctor-designation/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_DOCTOR_CATEGORY',
                                title: 'Category List',
                                type: 'item',
                                url: '/doctor-category/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_SPECIALITY',
                                title: 'Speciality List',
                                type: 'item',
                                url: '/speciality/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_SUB_SPECIALITY',
                                title: 'Sub Speciality List',
                                type: 'item',
                                url: '/sub-speciality/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_CHAMBER_TYPE',
                                title: 'Chamber Type List',
                                type: 'item',
                                url: '/chamber-type/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_PATIENT_TYPE',
                                title: 'Patient Type List',
                                type: 'item',
                                url: '/patient-type/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_SPECIAL_DAY',
                                title: 'Special Day List',
                                type: 'item',
                                url: '/special-day/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_DOCTOR_IMAGE_TYPE',
                                title: 'Image Type List',
                                type: 'item',
                                url: '/doctor-image-type/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    }
                ]
            },
            {
                id: 'DOCTOR_CALL',
                title: 'Doctor Call',
                translate: 'NAV.DOCTOR',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                url: '/dashboard/doctor',
                children: [
                    {
                        id: '',
                        title: 'Doctor Call',
                        translate: 'NAV.DOCTOR_VISIT',
                        type: 'collapsable',
                        icon: 'event_note',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_DOCTOR_VISIT',
                                title: 'Doctor Call List',
                                type: 'item',
                                url: '/doctor-visit/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_DOCTOR_VISIT_TYPE',
                                title: 'Doctor Call Type List',
                                type: 'item',
                                url: '/doctor-visit-type/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Visit',
                        translate: 'NAV.DOCTOR',
                        type: 'item',
                        icon: 'local_hospital',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_VISIT_FOR_DOCTOR',
                                title: 'Doctor Visit List',
                                type: 'item',
                                url: '/doctorVisit/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_VISIT_TYPE_FOR_DOCTOR',
                                title: 'Doctor Visit Type List',
                                type: 'item',
                                url: '/doctor-required-visit-type/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Sample & Gift',
                        translate: 'NAV.SAMPLE_STOCK',
                        type: 'collapsable',
                        icon: 'stock',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_SAMPLE_STOCK',
                                title: 'Sample Stock List',
                                type: 'item',
                                url: '/sample-stock/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_SAMPLE_STOCK_TRANSACTIONS',
                                title: 'Sample Transactions',
                                type: 'item',
                                url: '/sample-stock/transaction',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_SAMPLE_ALLOCATIONS',
                                title: 'Sample Stock Allocation List',
                                type: 'item',
                                url: '/sample-stock-allocation/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'TRANSFER_USER_SAMPLE_STOCK',
                                title: 'Transfer User Sample Stock',
                                type: 'item',
                                url: '/sample-stock/stock-transfer',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_SAMPLE_GIFT_CHALLAN',
                                title: 'Sample Gift Challan',
                                type: 'item',
                                url: '/sample-gift-challan/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    }
                ]
            },
            {
                id: 'RX',
                title: 'Rx',
                translate: 'NAV.DOCTOR',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                url: '/dashboard/doctor',
                children: [
                    {
                        id: '',
                        title: 'Rx',
                        translate: 'NAV.PRESCRIPTION',
                        type: 'collapsable',
                        icon: 'local_hospital',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_PRESCRIPTION',
                                title: 'Prescription List',
                                type: 'item',
                                url: '/prescription/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_PRESCRIPTION',
                                title: 'Prescription Gallery',
                                type: 'item',
                                url: '/prescription/gallery',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_SEEN_RX',
                                title: 'Seen RX List',
                                type: 'item',
                                url: '/seen-rx/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Rx Settings',
                        translate: 'NAV.PRESCRIPTION',
                        type: 'collapsable',
                        icon: 'local_hospital',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_PRESCRIPTION_TYPE',
                                title: 'Prescription Type List',
                                type: 'item',
                                url: '/prescription-type/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_PRESCRIPTION_TYPE',
                                title: 'RX Reject Reason List',
                                type: 'item',
                                url: '/reject-reason/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'MANAGE_RX_APPROVAL_RULE',
                                title: 'Approval Rule',
                                type: 'item',
                                url: '/prescription/approval-rule',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'MANAGE_RX_FROM',
                                title: 'Manage rx from',
                                type: 'item',
                                url: '/rxFrom/list',
                                description: '',
                                isActive: false
                            }
                        ]
                    }
                ]
            },
            {
                id: 'DOCTOR_SERVICE',
                title: 'Doctor Donation',
                translate: 'NAV.DOCTOR',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                url: '/dashboard/doctor',
                children: [
                    {
                        id: '',
                        title: 'Doctor Donation',
                        translate: 'NAV.DOCTOR_VISIT',
                        type: 'collapsable',
                        icon: 'event_note',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'DOCTOR_SERVICE_PROPOSAL_APPROVAL_RULE_VIEW',
                                title: 'Doctor Service Approval Rule List',
                                type: 'item',
                                url: '/doctor-service/list',
                                isActive: false,
                            },
                            {
                                id: 'DOCTOR_SERVICE_PROPOSAL_TYPE_VIEW',
                                title: 'Doctor Service Proposal Type List',
                                type: 'item',
                                url: '/doctor-service/type-list',
                                isActive: false,
                            },
                            {
                                id: 'DOCTOR_SERVICE_PAYMENT_METHOD_VIEW',
                                title: 'Doctor Payment Method List',
                                type: 'item',
                                url: '/doctor-service/method-list',
                                isActive: false,
                            },
                            {
                                id: 'DOCTOR_SERVICE_PROPOSAL_VIEW',
                                title: 'Doctor Service Proposal List',
                                type: 'item',
                                url: '/doctor-proposal/list',
                                isActive: false,
                            }
                        ]
                    },
                ]
            },
            {
                id: 'GEO_MARKET',
                title: 'Geo Market',
                translate: 'NAV.DOCTOR',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                url: '/dashboard/geo-market',
                children: [
                    {
                        id: '',
                        title: 'Geo Market',
                        translate: 'NAV.PRESCRIPTION',
                        type: 'collapsable',
                        icon: 'local_hospital',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_GEO_MARKET',
                                title: 'View Geo Markets',
                                type: 'item',
                                url: '/geo-market/list',
                                description: '',
                                isActive: false
                            }
                        ]
                    },
                ]
            },
            {
                id: 'RX_SURVEY',
                title: 'Rx Survey',
                translate: 'NAV.DOCTOR',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                url: '/dashboard/doctor',
                children: [
                    {
                        id: '',
                        title: 'Rx Survey',
                        translate: 'NAV.PRESCRIPTION',
                        type: 'collapsable',
                        icon: 'local_hospital',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_RX_SURVEY_TYPE',
                                title: 'RX Survey Type List',
                                type: 'item',
                                url: '/rx-survey-type/list',
                                description: '',
                                isActive: false
                            },
                            {
                                id: 'VIEW_RX_SURVEY',
                                title: 'RX Survey List',
                                type: 'item',
                                url: '/rx-survey/list',
                                description: '',
                                isActive: false
                            }
                        ]
                    },
                ]
            },
            {
                id: 'PRODUCT',
                title: 'Product',
                translate: 'NAV.PRODUCT',
                type: 'item',
                icon: 'local_mall',
                isActive: false,
                url: '/dashboard/product',
                children: [
                    {
                        id: '',
                        title: 'Product',
                        translate: 'NAV.PRODUCT',
                        type: 'collapsable',
                        icon: 'shopping_cart',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_PRODUCT',
                                title: 'Product List',
                                type: 'item',
                                url: '/product/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_COMPETITOR',
                                title: 'Competitor List',
                                type: 'item',
                                url: '/competitor/list',
                                isActive: false
                            },
                            {
                                id: 'VIEW_COMPETITOR_BRAND',
                                title: 'Competitor Brand List',
                                type: 'item',
                                url: '/competitor-brand/list',
                                isActive: false
                            },
                            {
                                id: 'VIEW_COMPETITOR_PRODUCT',
                                title: 'Competitor Product List',
                                type: 'item',
                                url: '/competitor/product-list',
                                isActive: false
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Product Settings',
                        translate: 'NAV.PRODUCT',
                        type: 'collapsable',
                        icon: 'shopping_cart',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_PRODUCT_LINE',
                                title: 'Product Line List',
                                type: 'item',
                                url: '/product-line/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_PRODUCT_BRAND',
                                title: 'Product Brand List',
                                type: 'item',
                                url: '/product-brand/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_PRODUCT_BRAND_TAG',
                                title: 'Product Brand Tag List',
                                type: 'item',
                                url: '/product-brand-tag/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_PRODUCT_TYPE',
                                title: 'Product Type List',
                                type: 'item',
                                url: '/product-type/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_THERAPEUTIC_GROUP',
                                title: 'Therapeutic Group List',
                                type: 'item',
                                url: '/therapeutic-group/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_GENERIC_GROUP',
                                title: 'Generic Group List',
                                type: 'item',
                                url: '/generic-group/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_PRODUCT_PRICE_LIST',
                                title: 'Product Price List',
                                type: 'item',
                                url: '/product-price/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'FOCUS_BRAND_VIEW',
                                title: 'Focus Brand List',
                                type: 'item',
                                url: '/product/focus-brand-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_PRODUCT_DOSE_FORM',
                                title: 'Product Dose Form List',
                                type: 'item',
                                url: '/product-dose-form/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    }
                ]
            },
            {
                id: 'SALES_&_COLLECTION',
                title: 'Sales & Collection',
                translate: 'NAV.ORDER',
                type: 'item',
                icon: 'shopping_cart',
                isActive: false,
                url: '/dashboard/sales-and-collection',
                children: [
                    {
                        id: '',
                        title: 'Sales',
                        translate: 'NAV.ORDER',
                        type: 'collapsable',
                        icon: 'shopping_cart',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_ORDER',
                                title: 'Order List',
                                type: 'item',
                                url: '/order/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'ORDER_ALPHA_VIEW',
                                title: 'Order List',
                                type: 'item',
                                url: '/order-alpha/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_ORDER_FOR_DEPOT_USER_DMS, VIEW_ORDER_DMS',
                                title: 'Order List',
                                type: 'item',
                                url: '/dms-order/dms-order-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_CAMPAIGN',
                                title: 'Campaign List',
                                type: 'item',
                                url: '/campaign/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_CAMPAIGNS_ON_DMS, CAMPAIGN_VIEW_FLAT_RATE, CAMPAIGN_VIEW_DISCOUNT_ON_SALES, CAMPAIGN_VIEW_BONUS',
                                title: 'Campaigns',
                                type: 'item',
                                url: '/dms-campaign/dms-campaign-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_INVOICE',
                                title: 'Invoice List',
                                type: 'item',
                                url: '/inv0ice/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'INVOICE_ALPHA_VIEW, INVOICE_ALPHA_VIEW_WITH_DA',
                                title: 'Invoice List',
                                type: 'item',
                                url: '/invoice-alpha/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'INVOICE_ALPHA_SUMMARY_VIEW,',
                                title: 'Generate Invoice Summary',
                                type: 'item',
                                url: '/invoice-alpha/generate-invoice-summary',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'INVOICE_ALPHA_SUMMARY_VIEW,',
                                title: 'Invoice Summary List',
                                type: 'item',
                                url: '/invoice-alpha/summary-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_SYNCED_INVOICE',
                                title: 'Invoice List',
                                type: 'item',
                                url: '/invoice-sync/list',
                                isActive: false
                            },
                            {
                                id: 'VIEW_INVOICE_FOR_DEPOT_USER_DMS',
                                title: 'Invoice List',
                                type: 'item',
                                url: '/dms-invoice/dms-invoice-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_INVOICE_WITH_DA_FOR_DEPOT_USER_DMS',
                                title: 'Invoice List',
                                type: 'item',
                                url: '/dms-invoice/dms-invoice-list-with-da',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_INVOICE_TYPE',
                                title: 'Invoice Type List',
                                type: 'item',
                                url: '/dms-invoice/invoice-type-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'DELIVERY_RETURN_ALPHA_VIEW',
                                title: 'Delivery Return List',
                                type: 'item',
                                url: '/delivery-return/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_DELIVERY',
                                title: 'Delivery List',
                                type: 'item',
                                url: '/delivary/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_RETURN',
                                title: 'Return List',
                                type: 'item',
                                url: '/return/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'DMS_VIEW_RETURN_REASON',
                                title: 'Return Reason List',
                                type: 'item',
                                url: '/dms-return-reason/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'DMS_VIEW_RETURNS',
                                title: 'Sales Return List',
                                type: 'item',
                                url: '/dms-sales-return/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'DMS_VIEW_DELIVERY_RETURN',
                                title: 'Delivery Return List',
                                type: 'item',
                                url: '/dms-invoice/delivery-return-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_CHEMIST_INCENTIVE',
                                title: 'Incentive Collection',
                                type: 'item',
                                url: '/incentive-collection/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_CHEMIST_INCENTIVE_RULE_BY_PAID_AMOUNT',
                                title: 'Incentive Rule List',
                                type: 'item',
                                url: '/incentive-collection/rule-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'UPLOAD_CHEMIST_INCENTIVE',
                                title: 'Upload Incentive',
                                type: 'item',
                                url: '/incentive-collection/upload-incentive',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_ORDER_APPROVAL_RULE',
                                title: 'Order Approval Rules',
                                type: 'item',
                                url: '/order-alpha-approval-rule/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Payment Collection',
                        translate: 'NAV.PAYMENT',
                        type: 'collapsable',
                        icon: 'payment',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_PAYMENT',
                                title: 'Payment List',
                                type: 'item',
                                url: '/payment/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_PAYMENT_METHOD',
                                title: 'Payment Method',
                                type: 'item',
                                url: '/payment-method/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_BANK_ACCOUNT',
                                title: 'Bank Account',
                                type: 'item',
                                url: '/bank-account/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_PAYMENTS_BY_DEPOT_USER',
                                title: 'Payment List',
                                type: 'item',
                                url: '/dms-payment/dms-payment-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_GROSS_PAYMENT_DMS',
                                title: 'Payment Collection List',
                                type: 'item',
                                url: '/payment-collection/list',
                                isActive: false,
                            },
                            {
                                id: 'ADJUST_RETURN_AMOUNT_VIEW_BY_ORGANIZATION_USER,ADJUST_RETURN_AMOUNT_VIEW_BY_DEPOT_USER,INCENTIVE_AMOUNT_ADJUSTMENT_VIEW_BY_ORGANIZATION_USER,INCENTIVE_AMOUNT_ADJUSTMENT_VIEW_BY_DEPOT_USER',
                                title: 'Invoice Adjustment List',
                                type: 'item',
                                url: '/adjust-payment/list',
                                isActive: false,
                                second_set_id: '',
                            },
                            {
                                id: 'CREATE_GROSS_PAYMENT_DMS',
                                title: 'Create Payment Collection',
                                type: 'item',
                                url: '/payment-collection/chemist-list-for-payment',
                                isActive: false,
                            },
                            {
                                id: 'VIEW_MPO_WISE_GROSS_PAYMENT',
                                title: 'MPO Wise Payment Collection List',
                                type: 'item',
                                url: '/payment-collection/mpo-wise-collection-list',
                                isActive: false,
                            }

                        ]
                    },

                ]
            },
            {
                id: 'STOCK',
                title: 'Stock',
                translate: 'NAV.ORDER',
                type: 'item',
                icon: 'shopping_cart',
                isActive: false,
                url: '/dashboard/sales-and-collection',
                children: [
                    {
                        id: '',
                        title: 'Central Stock',
                        translate: 'NAV.SALES_CENTER',
                        type: 'collapsable',
                        icon: 'shopping_cart',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_CENTRAL_STOCK',
                                title: 'Central Stock List',
                                type: 'item',
                                url: '/central-stock/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_TRANSFER_FROM_CENTRAL_STOCK',
                                title: 'Central Stock Transfer List',
                                type: 'item',
                                url: '/central-stock/stock-transfer-list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Stock',
                        translate: 'NAV.STOCK',
                        type: 'collapsable',
                        icon: 'stock',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_STOCK',
                                title: 'Stock List',
                                type: 'item',
                                url: '/stock/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Depot',
                        translate: 'NAV.DELIVERY',
                        type: 'collapsable',
                        icon: 'local_shipping',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_DEPOT_TYPE',
                                title: 'Depot Type List',
                                type: 'item',
                                url: '/depot-type/depot-type-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_DEPORT',
                                title: 'Depot List',
                                type: 'item',
                                url: '/depot/depot-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'UPLOAD_PRODUCT_STOCK_TO_DEPOT',
                                title: 'Upload Stock',
                                type: 'item',
                                url: '/depot/product-upload',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_DEPOT_STOCK',
                                title: 'Depot Stock List',
                                type: 'item',
                                url: '/depot/stock-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'ADJUST_DEPOT_STOCK',
                                title: 'Adjust Depot Stock',
                                type: 'item',
                                url: '/depot/adjust-depot-stock',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_SENT_DEPOT_REQUISITIONS',
                                title: 'Sent Requisition List',
                                type: 'item',
                                url: '/depot-requisition/sent-requisition-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_RECEIVED_DEPOT_REQUISITIONS',
                                title: 'Received Requisition List',
                                type: 'item',
                                url: '/depot-requisition/received-requisition-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_ISSUED_CHALLANS',
                                title: 'Issued Challan List',
                                type: 'item',
                                url: '/depot-challan/issued-challan-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_RECEIVED_CHALLANS',
                                title: 'Received Challan List',
                                type: 'item',
                                url: '/depot-challan/received-challan-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_PRODUCT_BATCH',
                                title: 'Product Batch List',
                                type: 'item',
                                url: '/depot-product-batch/depot-product-batch-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_FREE_CHALLAN_PURPOSE',
                                title: 'Free Challan Purpose List',
                                type: 'item',
                                url: '/free-challan-purpose/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_FREE_CHALLAN_ISSUE',
                                title: 'Free Challan Issue List',
                                type: 'item',
                                url: '/free-challan-issue/list',
                                isActive: false,
                                description: ''
                            },

                        ]
                    },

                    {
                        id: '',
                        title: 'Sales Center',
                        translate: 'NAV.SALES_CENTER',
                        type: 'collapsable',
                        icon: 'store',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_SALES_CENTER',
                                title: 'Sales Center List',
                                type: 'item',
                                url: '/sales-center/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'CREATE_SALES_CENTER',
                                title: 'Add New Sales Center',
                                type: 'item',
                                url: '/sales-center/add',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_DISTRIBUTION_ROUTE',
                                title: 'Distributor Route List',
                                type: 'item',
                                url: '/route/list',
                                isActive: false,
                                description: ''
                            },
                        ]
                    }

                ]
            },
            {
                id: 'REPLACEMENT',
                title: 'Replacement',
                translate: 'NAV.REPLACEMENT',
                type: 'collapsable',
                icon: 'swap_horiz',
                isActive: false,
                description: '',
                children: [
                    {
                        id: '',
                        title: 'Replacement',
                        translate: 'NAV.REPLACEMENT',
                        type: 'collapsable',
                        icon: 'swap_horiz',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_REPLACEMENT_REQUEST',
                                title: 'Replacement Request List',
                                type: 'item',
                                url: '/replacement-request/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    }
                ]
            },
            {
                id: 'DOCTOR_ORDER',
                title: 'Doctor Order',
                translate: 'NAV.ORDER',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'VIEW_DOCTOR_ORDER',
                        title: 'Doctor Order List',
                        type: 'item',
                        url: '/doctor-order/list',
                        isActive: false,
                        description: ''
                    }
                ]
            },
            {
                id: 'DOCTOR_ORDER',
                title: 'Doctor Order',
                translate: 'NAV.ORDER',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'VIEW_DOCTOR_ORDER',
                        title: 'Doctor Order List',
                        type: 'item',
                        url: '/doctor-order/list',
                        isActive: false,
                        description: ''
                    }
                ]
            },
            {
                id: 'SITE',
                title: 'Site',
                translate: 'NAV.SITE',
                type: 'collapsable',
                icon: 'my_location',
                isActive: false,
                url: '/dashboard/site',
                children: [
                    {
                        id: '',
                        title: 'Site',
                        translate: 'NAV.SITE',
                        type: 'collapsable',
                        icon: 'shopping_cart',
                        isActive: false,
                        children: [
                            {
                                id: 'VIEW_SITE',
                                title: 'Site List',
                                type: 'item',
                                url: '/site/list',
                                isActive: false
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Visit',
                        translate: 'NAV.SITE',
                        type: 'collapsable',
                        icon: 'shopping_cart',
                        isActive: false,
                        children: [
                            {
                                id: 'VIEW_VISIT_TYPE_FOR_SITE',
                                title: 'Site Visit Type List',
                                type: 'item',
                                url: '/site-visit-type/list',
                                isActive: false
                            },
                            {
                                id: 'VIEW_VISIT_FOR_SITE',
                                title: 'Site Visit List',
                                type: 'item',
                                url: '/siteVisit/list',
                                isActive: false
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Site Settings',
                        translate: 'NAV.SITE',
                        type: 'collapsable',
                        icon: 'shopping_cart',
                        isActive: false,
                        children: [
                            {
                                id: 'VIEW_SITE_TYPE',
                                title: 'Site Type List',
                                type: 'item',
                                url: '/siteType/list',
                                isActive: false
                            }
                            ,
                            {
                                id: 'VIEW_SITE_OWNER_TYPE',
                                title: 'Site Owner Type List',
                                type: 'item',
                                url: '/siteOwner/list',
                                isActive: false
                            }
                        ]
                    }
                ]
            },
            {
                id: 'TEAM',
                title: 'Team Management',
                translate: 'NAV.USER',
                type: 'item',
                icon: 'person',
                isActive: false,
                url: '/dashboard/team',
                children: [
                    {
                        id: '',
                        title: 'User',
                        translate: 'NAV.USER',
                        type: 'collapsable',
                        icon: 'person',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_USER',
                                title: 'User List',
                                type: 'item',
                                url: '/user/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'CREATE_USER',
                                title: 'Add New User',
                                type: 'item',
                                url: '/user/add',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'UPDATE_CREDIT_LIMIT',
                                title: 'Upload Credit Limit',
                                type: 'item',
                                url: '/user/credit-upload',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_DEPOT_USERS',
                                title: 'Depot User List',
                                type: 'item',
                                url: '/user/depot-user-list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: 'WEB_MENU_MARKET_STRUCTURE',
                        title: 'Market Structure',
                        translate: 'NAV.MARKET_HIERARCHY',
                        type: 'collapsable',
                        icon: 'device_hub',
                        isActive: false,
                        description: '',
                        children: []
                    },
                    {
                        id: '',
                        title: 'Vehicle',
                        translate: 'NAV.USER',
                        type: 'collapsable',
                        icon: 'person',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_USER_VEHICLE',
                                title: 'Vehicle List',
                                type: 'item',
                                url: '/vehicle/list',
                                description: '',
                                isActive: false
                            },
                        ]
                    },
                    {
                        id: 'ADMIN',
                        title: 'Organiztion',
                        translate: 'NAV.ORGANIZATION',
                        type: 'collapsable',
                        icon: 'admin_panel_settings',
                        isActive: false,
                        description: '',
                        children: []
                    }
                ]
            },
            {
                id: 'EXPENSE_CLAIM',
                title: 'TA/DA & Other Expenses',
                translate: 'NAV.EXPENSE_CLAIM',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                url: '/dashboard/expense-claim',
                children: [
                    {
                        id: '',
                        title: 'Other Expenses',
                        translate: 'NAV.EXPENSE_CLAIM',
                        type: 'collapsable',
                        icon: 'payment',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_EXPENSE_CLAIM',
                                title: 'Other Expense List',
                                type: 'item',
                                url: '/expenseclaim/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_MILEAGE_CLAIM',
                                title: 'Mileage Claim List',
                                type: 'item',
                                url: '/milage/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Monthly Allowance',
                        translate: 'NAV.EXPENSE_CLAIM',
                        type: 'collapsable',
                        icon: 'payment',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_MONTHLY_ALLOWANCE',
                                title: 'Monthly Allowance List',
                                type: 'item',
                                url: '/allowance/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'GENERATE_MONTHLY_EXPENSE',
                                title: 'Generate Monthly Allowance',
                                type: 'item',
                                url: '/user-allowance/allowance-claimed-user-list',
                                isActive: false
                            },
                            {
                                id: 'VIEW_MONTHLY_EXPENSE',
                                title: 'Monthly Allowance List',
                                type: 'item',
                                url: '/user-allowance/monthly-allowance-claim-list',
                                isActive: false
                            },
                            {
                                id: 'VIEW_MONTHLY_EXPENSE',
                                title: 'To Approve Monthly Allowance List',
                                type: 'item',
                                url: '/user-allowance/pending-monthly-allowance-list',
                                isActive: false
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Daily Allowance',
                        translate: 'NAV.EXPENSE_CLAIM',
                        type: 'collapsable',
                        icon: 'payment',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_TA_DA_RULE_BY_TOUR_OR_MARKET',
                                title: 'TaDa Market Rule List',
                                type: 'item',
                                url: '/tada-MarketRule/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_TA_DA_CLAIM',
                                title: 'TaDa Claim List',
                                type: 'item',
                                url: '/tadaClaim/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_DAILY_ALLOWANCE_CLAIM',
                                title: 'Daily Allowance List',
                                type: 'item',
                                url: '/da-claim/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'DAILY_ALLOWANCE_APPROVE',
                                title: 'To Approve Daily Allowance List',
                                type: 'item',
                                url: '/da-claim/pending-da-claim-list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Expense Claim Settings',
                        translate: 'NAV.EXPENSE_CLAIM',
                        type: 'collapsable',
                        icon: 'payment',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_EXPENSE_TYPE',
                                title: 'Expense Type List',
                                type: 'item',
                                url: '/expensetype/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_TRANSPORTATION_METHOD',
                                title: 'Transport List',
                                type: 'item',
                                url: '/transport/list',
                                description: '',
                                isActive: false
                            },
                            {
                                id: 'VIEW_USER_DISTANCE_WISE_TA_DA_RULE',
                                title: 'User Distance Wise TA/DA Rule',
                                type: 'item',
                                url: '/user-distance-wise-tada-rule/list',
                                description: '',
                                isActive: false
                            },
                            {
                                id: 'CREATE_USER_DISTANCE_WISE_TA_DA_RULE',
                                title: 'User Distance Wise TA/DA Rule Upload',
                                type: 'item',
                                url: '/user-distance-wise-tada-rule/upload',
                                isActive: false
                            },
                            {
                                id: 'VIEW_DAILY_ALLOWANCE_APPROVAL_RULE',
                                title: 'Daily Allowance Approval Rule',
                                type: 'item',
                                url: '/user-allowance-approval-rule/daily-allowance-approval-rule-list',
                                isActive: false
                            },
                            {
                                id: 'VIEW_MONTHLY_EXPENSE_APPROVAL_RULE',
                                title: 'Monthly Allowance Approval Rule',
                                type: 'item',
                                url: '/user-allowance-approval-rule/monthly-allowance-approval-rule-list',
                                isActive: false
                            },
                            {
                                id: 'VIEW_ROLE_WISE_MONTHLY_ALLOWANCES',
                                title: 'Role Wise Monthly Allowances',
                                type: 'item',
                                url: '/user-role-wise-allowance-rule/role-wise-monthly-allowance',
                                isActive: false
                            },
                            {
                                id: 'VIEW_ROLE_WISE_ALLOWANCES',
                                title: 'Role Wise Daily Allowances',
                                type: 'item',
                                url: '/user-role-wise-allowance-rule/daily-allowance-rule-list',
                                isActive: false
                            },
                            {
                                id: 'VIEW_ROLE_WISE_EXPENSE_TYPE',
                                title: 'Role Wise Expense Type',
                                type: 'item',
                                url: '/role-wise-expense-type/list',
                                isActive: false
                            },
                        ]
                    }
                ]
            },
            {
                id: 'OTHERS',
                title: 'Others',
                translate: 'NAV.OTHERS',
                type: 'collapsable',
                icon: 'more_horiz',
                isActive: false,
                url: '/dashboard/others',
                children: [
                    {
                        id: 'WEB_MENU_CONTACT',
                        title: 'Contact',
                        translate: 'NAV.OTHERS',
                        type: 'collapsable',
                        icon: 'more_horiz',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_CONTACT_TYPE',
                                title: 'Contact Type List',
                                type: 'item',
                                url: '/contact-type/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: 'WEB_MENU_SEGMENT',
                        title: 'Segment',
                        translate: 'NAV.OTHERS',
                        type: 'collapsable',
                        icon: 'more_horiz',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_SEGMENT',
                                title: 'Group List',
                                type: 'item',
                                url: '/group/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: 'WEB_MENU_SEGMENT',
                        title: 'Sub-Segment',
                        translate: 'NAV.OTHERS',
                        type: 'collapsable',
                        icon: 'more_horiz',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_SUB_SEGMENT',
                                title: 'Sub-Group List',
                                type: 'item',
                                url: '/sub-group/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    }
                ]
            },
            {
                id: 'HR',
                title: 'HR',
                translate: 'NAV.ATTENDANCE',
                type: 'item',
                icon: 'fingerprint',
                isActive: false,
                url: '/dashboard/hr',
                children: [
                    {
                        id: '',
                        title: 'Attendance',
                        translate: 'NAV.ATTENDANCE',
                        type: 'collapsable',
                        icon: 'fingerprint',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_ATTENDANCE',
                                title: 'Attendance List',
                                type: 'item',
                                url: '/attendance/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_ATTENDANCE',
                                title: 'Attendance Gallery List',
                                type: 'item',
                                url: '/attendance/gallery-list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Leave',
                        translate: 'NAV.ATTENDANCE',
                        type: 'collapsable',
                        icon: 'local_hotel',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_LEAVE_TYPE',
                                title: 'Leave Type List',
                                type: 'item',
                                url: '/leave-type/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_LEAVE_ALLOCATION',
                                title: 'Leave Allocation List',
                                type: 'item',
                                url: '/leave-allocation/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_LEAVE',
                                title: 'Leave List',
                                type: 'item',
                                url: '/leave/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_LEAVE_ACCOUNT',
                                title: 'Leave Account',
                                type: 'item',
                                url: '/leave-account/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Notice Board',
                        translate: 'NAV.NOTICE',
                        type: 'collapsable',
                        icon: 'notifications',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_NOTICE',
                                title: 'Notice Board List',
                                type: 'item',
                                url: '/notice-board/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'HR Settings',
                        translate: 'NAV.ATTENDANCE',
                        type: 'collapsable',
                        icon: 'local_hotel',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_HOLIDAY',
                                title: 'Holiday List',
                                type: 'item',
                                url: '/holiday/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_WEEKEND_REQUEST',
                                title: 'Weekly Holiday Request List',
                                type: 'item',
                                url: '/holiday/weekend-request-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_MONTHLY_WEEKEND',
                                title: 'Weekly Holiday List',
                                type: 'item',
                                url: '/weekend/weekend-user-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_MONTHLY_WEEKEND_REQUEST',
                                title: 'Monthly Weekly Holiday Request List',
                                type: 'item',
                                url: '/weekend/request-list',
                                isActive: false
                            },
                            {
                                id: 'VIEW_DAILY_SHIFT',
                                title: 'Daily Shift List',
                                type: 'item',
                                url: '/daily-shift/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    }
                ]
            },
            {
                id: 'TRAINING_&_EXAM',
                title: 'Training & Exam',
                translate: 'NAV.ATTENDANCE',
                type: 'item',
                icon: 'fingerprint',
                isActive: false,
                url: '/dashboard/hr',
                children: [
                    {
                        id: '',
                        title: 'Training',
                        translate: 'NAV.TRAINING',
                        type: 'collapsable',
                        icon: 'school',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_TRAINING',
                                title: 'Training List',
                                type: 'item',
                                url: '/training/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Exam',
                        translate: 'NAV.SURVEY',
                        type: 'collapsable',
                        icon: 'event_note',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_EXAM',
                                title: 'Exam List',
                                type: 'item',
                                url: '/exam-list/view',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_EXAM_UNDER_ME',
                                title: 'Exam List',
                                type: 'item',
                                url: '/exam-v2/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    }
                ]
            },
            {
                id: 'LOCATION',
                title: 'Location',
                translate: 'NAV.LOCATION',
                type: 'item',
                icon: 'person_pin_circle',
                isActive: false,
                url: '/dashboard/location',
                children: [
                    {
                        id: '',
                        title: 'Location Items',
                        translate: 'NAV.LOCATION',
                        type: 'item',
                        icon: 'person_pin_circle',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_LOCATION',
                                title: 'User Tracking(Old)',
                                type: 'item',
                                url: '/location/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_LOCATION',
                                title: 'User Last Location(Old)',
                                type: 'item',
                                url: '/location/user-location',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_LOCATION',
                                title: 'Timeline By Multiple Dates(Old)',
                                type: 'item',
                                url: '/location/timeline-by-multiple-dates',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_CHEMIST_AND_DOCTOR_LOCATION',
                                title: 'Doctor/Chemist Location',
                                type: 'item',
                                url: '/location/doctor-chemist-location',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'MONITOR_TEAM_TRACKING',
                                title: 'User Last Locations',
                                type: 'item',
                                url: '/location/user-last-locations',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'MONITOR_TEAM_TRACKING',
                                title: 'User Timeline by Date',
                                type: 'item',
                                url: '/location/user-timeline-by-date',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'MONITOR_TEAM_TRACKING',
                                title: 'User Timeline by Date Range',
                                type: 'item',
                                url: '/location/user-timeline-by-date-range',
                                isActive: false,
                                description: ''
                            }
                        ]
                    }
                ]
            },
            {
                id: 'KPI',
                title: 'KPI',
                translate: 'NAV.TARGET_ACHIEVEMENT',
                type: 'collapsable',
                icon: 'insert_chart',
                isActive: false,
                url: '/dashboard/kpi',
                children: [
                    {
                        id: '',
                        title: 'Target Achievement',
                        translate: 'NAV.TARGET_ACHIEVEMENT',
                        type: 'collapsable',
                        icon: 'insert_chart',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_MARKET_SALES_TARGET',
                                title: 'Market-wise Sales Target',
                                type: 'item',
                                url: '/target/market-wise-target',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_MARKET_SALES_TARGET_ACHIEVEMENT',
                                title: 'Market-wise Sales Achievement',
                                type: 'item',
                                url: '/target/market-wise-achievement',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_DAILY_SALES_TARGET_ACHIEVEMENT',
                                title: 'Daily Sales Achievement',
                                type: 'item',
                                url: '/target/daily-sales-achievement',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_MARKET_AND_PRODUCT_SALES_TARGET_ACHIEVEMENT',
                                title: 'Product-wise Sales Target',
                                type: 'item',
                                url: '/target/product-wise-target',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_MARKET_AND_PRODUCT_SALES_TARGET_ACHIEVEMENT',
                                title: 'Product-wise Sales Achievement',
                                type: 'item',
                                url: '/target/product-wise-achievement',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'MARKET_PRODUCT_TARGET_ACHIEVEMENT_WITH_REMAINING',
                                title: 'Market Product Sales Target Achievement',
                                type: 'item',
                                url: '/target/market-product-sales-target-list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'MARKET_PRODUCT_TARGET_ACHIEVEMENT_IN_QUARTER_WITH_REMAINING',
                                title: 'Market Product Sales Quarter Target Achievement',
                                type: 'item',
                                url: '/target/market-product-sales-target-list-quarter',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_RX_TARGET',
                                title: 'User Rx Monthly Target',
                                type: 'item',
                                url: '/target/user-monthly-rx-target',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'REPORT_RX_TARGET_OF_USER_AND_RX_COUNT',
                                title: 'User Rx Target & Count',
                                type: 'item',
                                url: '/target/user-rx-target-and-count',
                                isActive: false
                            }

                        ]
                    },
                ]
            },
            {
                id: 'WORK_SCHEDULE',
                title: 'Work Schedule',
                translate: 'NAV.ATTENDANCE',
                type: 'item',
                icon: 'fingerprint',
                isActive: false,
                url: '/dashboard/hr',
                children: [
                    {
                        id: '',
                        title: 'DVP',
                        translate: 'NAV.TRAINING',
                        type: 'collapsable',
                        icon: 'school',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_DOCTOR_VISIT_PLAN',
                                title: 'DVP List',
                                type: 'item',
                                url: '/doctor-visit-plan/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Planned User List',
                        translate: 'NAV.TRAINING',
                        type: 'collapsable',
                        icon: 'school',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_DOCTOR_VISIT_PLAN',
                                title: 'Visit Plan Planned User List',
                                type: 'item',
                                url: '/doctor-visit-plan/planned-user-list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Tour Plan',
                        translate: 'NAV.TOUR_PLAN',
                        type: 'collapsable',
                        icon: 'event',
                        isActive: false,
                        description: '',
                        children: [
                            {
                                id: 'VIEW_TOUR_PLAN',
                                title: 'Tour Planned User List',
                                type: 'item',
                                url: '/tour-plan/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_TOUR_TYPE',
                                title: 'Tour Type List',
                                type: 'item',
                                url: '/tour-type/list',
                                isActive: false,
                                description: ''
                            },
                            {
                                id: 'VIEW_TOUR_PURPOSE',
                                title: 'Tour Purpose List',
                                type: 'item',
                                url: '/tour-purpose/list',
                                isActive: false,
                                description: ''
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        id: 'REPORT',
        title: 'Report',
        translate: 'NAV.REPORT',
        type: 'group',
        icon: 'bar_chart',
        isActive: false,
        url: '/dashboard/report',
        children: [
            {
                id: 'user_attendance_report',
                title: 'Attendance Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'fingerprint',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'REPORT_DAY_WISE_ATTENDANCE_WITH_SHIFT',
                        title: 'Daily Shift-wise Attendance',
                        type: 'item',
                        url: '/report-attendance/shift-wise-user-list',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_MARKET_PRESENCE_REPORT',
                        title: 'Market Presence Count',
                        type: 'item',
                        url: '/report-attendance/market-presence-count',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_VIEW_ATTENDANCE_REGISTRAR',
                        title: 'Attendance Registry',
                        type: 'item',
                        url: '/report-attendance/registry',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_ATTENDANCE_STATUS_REGISTRAR',
                        title: 'Daily Status Registry',
                        type: 'item',
                        url: '/report-attendance/daily-status-registrar-list',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_ATTENDANCE_STATUS_REGISTRAR_V2',
                        title: 'Attendance Status Registrar',
                        type: 'item',
                        url: '/report-attendance/attendance-status-registrar',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'PRESENCE_REPORT',
                        title: 'Presence Report',
                        type: 'item',
                        url: '/report-attendance/presence-report',
                        isActive: false
                    },
                    {
                        id: 'MARKET_WISE_PRESENT_ABSENT_REPORT',
                        title: 'Present Absent Report',
                        type: 'item',
                        url: '/report-attendance/present-absent-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_ROLE_WISE_PER_DAY_ATTENDANCE_COUNT',
                        title: 'User Role-wise Attendance',
                        type: 'item',
                        url: '/report-attendance/attended-userrole-list',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_MARKET_WISE_ATTENDED_ABSENT_COUNT',
                        title: 'Attended Absent Count',
                        type: 'item',
                        url: '/report-attendance/market-wise-attended-absent-count',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_ABSENT_SUMMARY',
                        title: 'Absent Summary',
                        type: 'item',
                        url: '/report-attendance/absent-summary',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_ROLE_WISE_ABSENT_COUNT',
                        title: 'Role Wise Absent Count',
                        type: 'item',
                        url: '/report-attendance/role-wise-absent-count',
                        isActive: false,
                        description: ''
                    }

                ]
            },
            {
                id: 'DOCTOR_ORDER',
                title: 'Doctor Order Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'fingerprint',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'DOCTOR_ORDER_MARKET_SUMMARY_REPORT',
                        title: 'Market Wise Sales Summary Report',
                        type: 'item',
                        url: '/doctor-order-report/market-sales-summary-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'DOCTOR_ORDER_SUMMARY_REPORT',
                        title: 'Doctor Wise Sales Summary Report',
                        type: 'item',
                        url: '/doctor-order-report/sales-summary-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_DOCTOR_ORDER_PRODUCT_SALES_SUMMARY',
                        title: 'Product Sales Summary Report',
                        type: 'item',
                        url: '/doctor-order-report/product-summary-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_DOCTOR_ORDER_BRAND_WISE_SALES_SUMMARY',
                        title: 'Brand Sales Summary Report',
                        type: 'item',
                        url: '/doctor-order-report/brand-summary-report',
                        isActive: false,
                        description: ''
                    }

                ]
            },
            {
                id: 'user_report',
                title: 'User Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'person',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'REPORT_USER_ACTIVE_DAY_COUNT',
                        title: 'Active User Count Report',
                        type: 'item',
                        url: '/report-user-count/active-day-count',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'USER_DUE_REPORT',
                        title: 'Due Report',
                        type: 'item',
                        url: '/due-report/list',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'VIEW_USER_LEDGER',
                        title: 'User Ledger Report',
                        type: 'item',
                        url: '/user-ledger/list',
                        isActive: false,
                        description: ''
                    }
                ]
            },
            {
                id: 'sample_stock_report',
                title: 'Sample Stock Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'REPORT_SAMPLE_STOCK_ALLOCATION_OPENING_AND_CLOSING_REPORT',
                        title: 'Allocation Opening Closing Report',
                        type: 'item',
                        url: '/sample-stock-allocation-report/report-sample-allocation',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_PRODUCT_WISE_SAMPLE_STOCK_OPENING_CLOSING_REPORT',
                        title: 'Product Wise Allocation Opening Closing Report',
                        type: 'item',
                        url: '/sample-stock-allocation-report/report-product-wise-sample-allocation',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'SAMPLE_STOCK_ALLOCATION_SUMMARY',
                        title: 'Sample Stock Allocation Summary',
                        type: 'item',
                        url: '/sample-stock-allocation/summary',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'SAMPLE_STOCK_SUMMARY',
                        title: 'Sample Stock Summary',
                        type: 'item',
                        url: '/sample-stock/summary',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'SAMPLE_STOCK_USAGE_REPORT',
                        title: 'Usage Report',
                        type: 'item',
                        url: '/sample-stock-allocation-report/usage-report',
                        isActive: false,
                        description: ''
                    }
                ]
            },
            {
                id: 'doctor_report',
                title: 'Doctor Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'REPORT_DOCTOR_COVERAGE_BY_MARKET',
                        title: 'Doctor Coverage Report',
                        type: 'item',
                        url: '/report-doctor-coverage/doctor-coverage',
                        isActive: false,
                        description: 'The report provides an analysis of the number of doctors visited from markets in a given date range. ' +
                            'The report includes a detailed breakdown of the count of doctors seen each day, allowing for a comprehensive overview of market\'s visitation patterns.'
                    },
                    {
                        id: 'REPORT_DOCTOR_EXPECTED_PRODUCT_VS_RETURN',
                        title: 'Expected Product VS Return RX Report',
                        type: 'item',
                        url: '/report-doctor/expected-product-vs-return-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'MARKET_SPECIALITY_WISE_DOCTOR_COUNT',
                        title: 'Market Speciality Wise Count Report',
                        type: 'item',
                        url: '/report-doctor/market-speciality-wise-count',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'USER_WISE_DOCTOR_COUNT',
                        title: 'User Wise Doctor Count Report',
                        type: 'item',
                        url: '/report-doctor/user-wise-doctor-count',
                        isActive: false
                    },
                    {
                        id: 'DOCTOR_S_RX_AND_VISIT_FREQUENCY',
                        title: 'Rx DCR Frequency',
                        type: 'item',
                        url: '/report-doctor/rx-dcr-frequencies',
                        isActive: false
                    }
                ]
            },
            {
                id: 'doctor_visit_report',
                title: 'Doctor Call Plan Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'REPORT_VIEW_DOCTOR_CALL_PLAN',
                        title: 'Doctor Call Plan Report',
                        type: 'item',
                        url: '/report-visitplan/doctor-call-plan',
                        isActive: false,
                        description: 'The report provides a comprehensive plan for visiting doctors in a given date range. ' +
                            'The report includes a detailed breakdown of the scheduled visits for each doctor, organized by date in a tabular format.'
                    },
                    {
                        id: 'REPORT_VIEW_DOCTOR_PRODUCT_CALL_PLAN',
                        title: 'Doctor Product Call Plan Report',
                        type: 'item',
                        url: '/report-visitplan/doctor-product-call-plan',
                        isActive: false,
                        description: 'The report provides a detailed plan for visiting doctors, organized by doctors and products. ' +
                            'The report includes a comprehensive breakdown of the scheduled visits for each doctor, specifying which product is to be promoted during the visit.'
                    }]
            },
            {
                id: 'doctor_visit_report',
                title: 'Doctor Call Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'directions_walk',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'REPORT_USER_DCR_CALENDAR',
                        title: 'User DCR Report',
                        type: 'item',
                        url: '/report-dcr/user-dcr-calendar',
                        isActive: false,
                        description: 'The report provides an analysis of the number of doctors visited by each employee in a given date range. ' +
                            'The report includes a detailed breakdown of the count of doctors seen by each employee on each day, allowing for a ' +
                            'comprehensive overview of employee visitation patterns.'
                    },
                    {
                        id: 'REPORT_USER_BRAND_DCR_REPORT',
                        title: 'User Brand DCR Report',
                        type: 'item',
                        url: '/report-dcr/user-brand-dcr-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_DOCTOR_WISE_SAMPLE_GIFT_PPM_COUNT',
                        title: 'Doctor Sample Gift Report',
                        type: 'item',
                        url: '/report-dcr/doctor-wise-sample-gift-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_USER_DAILY_DCR_REPORT',
                        title: 'User Wise Daily DCR Report',
                        type: 'item',
                        url: '/report-dcr/user-daily-dcr-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_DOCTOR_DCR_CALENDAR',
                        title: 'Doctor DCR Report',
                        type: 'item',
                        url: '/report-dcr/doctor-dcr-calendar',
                        isActive: false,
                        description: 'The report includes a comprehensive breakdown of the count of visits to each doctor on each day in a given date range.'
                    },
                    {
                        id: 'REPORT_DOCTOR_MARKET_DCR_REPORT',
                        title: 'Doctor Market DCR Report',
                        type: 'item',
                        url: '/report-dcr/doctor-market-dcr-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_PRODUCT_BRAND_DCR_CALENDAR',
                        title: 'Product Brand DCR Report',
                        type: 'item',
                        url: '/report-dcr/product-brand-dcr-calendar',
                        isActive: false,
                        description: 'The report includes a comprehensive breakdown of the count of promotions done for each brand on each day, ' +
                            'allowing for a comprehensive overview of promotion patterns.'
                    },
                    {
                        id: 'REPORT_PRODUCT_DCR_CALENDAR',
                        title: 'Product DCR Report',
                        type: 'item',
                        url: '/report-dcr/product-dcr-calendar',
                        isActive: false,
                        description: 'The report includes a comprehensive breakdown of the count of promotions done for each product on each day, ' +
                            'allowing for a comprehensive overview of promotion patterns.'
                    },
                    {
                        id: 'REPORT_USER_DOCTOR_AND_BRAND_DCR_REPORT',
                        title: 'User Doctor Brand DCR Report',
                        type: 'item',
                        url: '/report-dcr/user-doctor-brand-list',
                        isActive: false,
                        description: 'The report provides a detailed analysis of the promotional activity of each employee for each brand with respect to the number ' +
                            'of promotions made to each doctor in a given date range. The report includes a comprehensive breakdown of the count of promotions made by ' +
                            'each employee for each brand to each doctor, ' + 'allowing for a comprehensive overview of promotional patterns.'
                    },
                    {
                        id: 'REPORT_USER_DOCTOR_PRODUCT_DCR_REPORT',
                        title: 'Market Doctor Product DCR Report',
                        type: 'item',
                        url: '/report-dcr/market-doctor-product-dcr-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_DCR_SUMMARY_BY_DOCTOR_PRODUCT',
                        title: 'Doctor Product DCR Report',
                        type: 'item',
                        url: '/report-dcr/doctor-product-dcr-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_COMPARE_DCR_COUNT_FROM_MARKET_WITH_LAST_MONTH',
                        title: 'DCR Comparison',
                        type: 'item',
                        url: '/report-dcr/dcr-comparison',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_MONTHLY_USER_DCR_COUNT',
                        title: 'Monthly User DCR Count',
                        type: 'item',
                        url: '/report-dcr/monthly-user-dcr-count',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_MARKET_WISE_DCR_COUNT_BY_PRODUCT',
                        title: 'Market Product DCR Report',
                        type: 'item',
                        url: '/report-dcr/market-product-dcr-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_MARKET_WISE_PRODUCT_DISTRIBUTION',
                        title: 'Market Product Distribution Report',
                        type: 'item',
                        url: '/report-dcr/market-product-distribution-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_ACCOMPANY_CALL_REPORT',
                        title: 'Accompany Call Report',
                        type: 'item',
                        url: '/report-dcr/accompany-call-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_DCR_COUNT_BY_PRODUCT_SEGMENT',
                        title: 'Accompany Call Report',
                        type: 'item',
                        url: '/report-dcr/accompany-call-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_DOCTOR_VISIT_PLAN_VS_DOCTOR_VISIT_OF_ONE_USER',
                        title: 'Visit Plan vs Visit of One User',
                        type: 'item',
                        url: '/doctor-visit-plan/plan-vs-visit-of-one-user',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_DOCTOR_VISIT_PLAN_VS_DOCTOR_VISIT',
                        title: 'Visit Plan vs Visit',
                        type: 'item',
                        url: '/doctor-visit-plan/plan-vs-visit',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'DOCTOR_VISIT_PLAN_USER_WISE_PLAN_VS_VISIT_REPORT',
                        title: 'User Wise Plan VS Visit',
                        type: 'item',
                        url: '/report-dcr/user-wise-plan-vs-visit-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_VISIT_COUNT_BY_USER',
                        title: 'Doctor Visit Count By User Report',
                        type: 'item',
                        url: '/report-dcr/doctor-visit-count-by-user-report',
                        isActive: false
                    },
                    {
                        id: 'DOCTOR_MARKET_WISE_VISIT_MONITORING_REPORT',
                        title: 'Doctor Market Wise Visit Monitoring Report',
                        type: 'item',
                        url: '/report-dcr/doctor-market-wise-visit-monitoring',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_WISE_PROMOTED_PRODUCTS',
                        title: 'Doctor Wise Promoted Products Report',
                        type: 'item',
                        url: '/report-dcr/doctor-wise-promoted-products',
                        isActive: false
                    }
                ]
            },
            {
                id: 'doctor_report',
                title: 'Prescription Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'receipt',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'REPORT_USER_RX_CALENDAR',
                        title: 'User RX Report',
                        type: 'item',
                        url: '/report-prescription/user-rx-calendar',
                        isActive: false,
                        description: 'The report includes a comprehensive breakdown of the count of Rx snaps taken by each employee on each date, ' +
                            'allowing for a comprehensive overview of Rx snap patterns.'
                    },
                    {
                        id: 'REPORT_USER_SEEN_RX_CALENDAR',
                        title: 'User Seen RX Report',
                        type: 'item',
                        url: '/report-prescription/report-user-seen-rx',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_DOCTOR_MARKET_RX_COUNT',
                        title: 'Doctor Market RX Count Report',
                        type: 'item',
                        url: '/report-prescription/report-doctor-market-rx-count',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_DOCTOR_MARKET_RX_CALENDAR',
                        title: 'Doctor\'s Market Wise Rx Report',
                        type: 'item',
                        url: '/report-prescription/report-doctor-market-calender-rx-count',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_MARKET_RX_CALENDAR',
                        title: 'Market RX Report',
                        type: 'item',
                        url: '/report-prescription/report-market-rx-calender',
                        isActive: false,
                        description: 'The report provides a detailed analysis of the number of prescription (Rx) snaps taken ' +
                            'by markets on each date in a given date range. Using data collected during the specified time period, ' +
                            'the report highlights the most active markets in terms of Rx snap count.'
                    },
                    {
                        id: 'REPORT_MARKET_WISE_RX_COUNT_BY_MONTH',
                        title: 'Market Wise Rx Count by Month',
                        type: 'item',
                        url: '/report-prescription/monthly-market-rx-count',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_MARKET_PRODUCT_WISE_RX_COUNT_BY_MONTH',
                        title: 'Market Product Wise Rx Count by Month',
                        type: 'item',
                        url: '/report-prescription/monthly-market-product-rx-count',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_DOCTOR_WISE_RX_COUNT_BY_PRODUCT',
                        title: 'Doctor\'s Product Wise Rx',
                        type: 'item',
                        url: '/report-prescription/doctor-wise-rx-count-by-product-list',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_MARKET_PRESCRIBER_CALENDAR',
                        title: 'Market Prescriber Report',
                        type: 'item',
                        url: '/report-prescription/report-market-prescriber-calender',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_MONTHLY_USER_RX_COUNT',
                        title: 'Monthly User RX Count Report',
                        type: 'item',
                        url: '/report-prescription/report-user-rx-monthly-count',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_MONTHLY_DOCTOR_RX_COUNT',
                        title: 'Monthly Doctor RX Count Report',
                        type: 'item',
                        url: '/report-prescription/report-doctor-rx-monthly-count',
                        isActive: false,
                        description: ''
                    },

                    {
                        id: 'REPORT_DOCTOR_RX_CALENDAR',
                        title: 'Doctor RX Report',
                        type: 'item',
                        url: '/report-prescription/doctor-rx-calendar',
                        isActive: false,
                        description: 'The report provides a detailed analysis of the number of prescription (Rx) snaps taken' +
                            ' from each doctor on each date in a given date range.'
                    },
                    {
                        id: 'REPORT_PRODUCT_BRAND_RX_CALENDAR',
                        title: 'Product Brand RX Report',
                        type: 'item',
                        url: '/report-prescription/product-brand-rx-calendar',
                        isActive: false,
                        description: 'The report provides a analysis of the number of prescription (Rx) snaps taken for ' +
                            'each brand on each date in a given date range. the report highlights the most popular brands in ' +
                            'terms of Rx snap count and identifies any trends or patterns in brand performance.'
                    },
                    {
                        id: 'REPORT_MARKET_BRAND_RX_CALENDAR',
                        title: 'Market Brand RX Report',
                        type: 'item',
                        url: '/report-prescription/market-brand-calender-rx',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_DOCTOR_BRAND_RX_COUNT',
                        title: 'Doctor\'s Brand Wise Rx',
                        type: 'item',
                        url: '/report-prescription/doctor-brand-wise-list',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_USER_BRAND_RX_COUNT',
                        title: 'User Brand RX Report',
                        type: 'item',
                        url: '/report-prescription/user-brand-rx-calendar',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_PRODUCT_RX_CALENDAR',
                        title: 'Product RX Report',
                        type: 'item',
                        url: '/report-prescription/product-rx-calendar',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_INSTITUTE_RX_CALENDAR',
                        title: 'Institute RX Report',
                        type: 'item',
                        url: '/report-prescription/institute-rx',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_INSTITUTE_BRAND_RX_COUNT',
                        title: 'Institute Brand RX Report',
                        type: 'item',
                        url: '/report-prescription/institute-brand-rx',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_RX_COUNT_BY_USER_AND_RX_TYPE',
                        title: 'Type Wise User RX Count',
                        type: 'item',
                        url: '/report-prescription/rx-count-by-user-and-rx-type',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_COMPARE_RX_COUNT_FROM_MARKET_WITH_LAST_MONTH',
                        title: 'RX Comparison',
                        type: 'item',
                        url: '/report-prescription/rx-comparison',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_MARKET_AND_PRODUCT_WISE_RX_COUNT_ANALYSIS_REPORT',
                        title: 'Market and Product-wise Rx Count Analysis Report',
                        type: 'item',
                        url: '/report-prescription/market-product-rx',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'ORION_RX_TARGET_REPORT',
                        title: 'Rx Target Report',
                        type: 'item',
                        url: '/report-prescription/rx-target',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'USER_WISE_RX_COUNT_BY_RX_TYPE',
                        title: 'User Wise Rx Count By Rx Type Report',
                        type: 'item',
                        url: '/report-prescription/user-wise-rx-count-by-rx-type',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'USER_AND_PRODUCT_WISE_RX_COUNT_REPORT',
                        title: 'User and Product Wise Rx Count Report',
                        type: 'item',
                        url: '/report-prescription/user-and-product-wise-rx-count',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'USER_ROLE_WISE_RX_COUNT_REPORT',
                        title: `Doctor's User Role-wise Rx Count Report`,
                        type: 'item',
                        url: '/report-prescription/user-role-wise-rx-count',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'MARKET_WISE_RX_PRODUCTIVE_REPORT',
                        title: `Rx Productive Report`,
                        type: 'item',
                        url: '/report-prescription/rx-productive-count',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'MARKET_WISE_RX_COMPARISON_REPORT',
                        title: `Market Wise Rx Comparison Report`,
                        type: 'item',
                        url: '/report-prescription/market-wise-rx-comparison-report',
                        isActive: false,
                        description: ''
                    }
                ]
            },
            {
                id: 'doctor_report',
                title: 'Rx Survey Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'receipt',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'MARKET_WISE_RX_SHARE',
                        title: 'Market Wise Rx Share Report',
                        type: 'item',
                        url: '/report-prescription/market-wise-rx-share',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'MARKET_DATE_WISE_RX_SHARE_DETAILS',
                        title: 'Market & Date Wise Rx Share Report',
                        type: 'item',
                        url: '/report-prescription/market-date-wise-rx-share-with-details',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'PRODUCT_WISE_RX_SURVEY',
                        title: 'Product Wise Rx Survey Report',
                        type: 'item',
                        url: '/report-prescription/product-wise-rx-survey',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'DOCTOR_WISE_RX_SURVEY',
                        title: 'Doctor Wise Rx Survey Report',
                        type: 'item',
                        url: '/report-prescription/doctor-wise-rx-survey',
                        isActive: false,
                        description: ''
                    }
                ]
            },
            {
                id: 'TOUR_PLAN',
                title: 'Tour Plan Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'receipt',
                isActive: false,
                children: [
                    {
                        id: 'USER_WISE_MONTHLY_TOUR_PLAN_REPORT',
                        title: 'Tour Plan User Wise Monthly Report',
                        type: 'item',
                        url: '/report-tour-plan/tour-plan-user-wise-monthly-report',
                        isActive: false
                    }
                ]
            },
            {
                id: 'order_report',
                title: 'Expense Claim Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'REPORT_MONTHLY_TA_DA_AND_MILEAGE_OF_USER',
                        title: 'Monthly Expense Claim Report',
                        type: 'item',
                        url: '/report-expense-claim/monthly-expense-claim-list',
                        isActive: false,
                        description: ''
                    }
                ]
            },
            {
                id: 'order_report',
                title: 'Order Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'REPORT_DETAILED_ORDER_REPORT',
                        title: 'Detailed Report',
                        type: 'item',
                        url: '/order-report-detail/list',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_ORDER_SUMMARY_BY_CHEMIST',
                        title: 'Order Summary By Chemist',
                        type: 'item',
                        url: '/order-report-summary-chemist/list',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_ORDER_SUMMARY_BY_PRODUCT',
                        title: 'Order Summary By Product',
                        type: 'item',
                        url: '/order-report-summary-product/list',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'REPORT_ORDERED_QUANTITY',
                        title: 'Ordered Quantity For User',
                        type: 'item',
                        url: '/order-report-user/ordered-quantity-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'ORDER_ALPHA_ORDER_BY_MPO',
                        title: 'Order By Mpo Report',
                        type: 'item',
                        url: '/report-order-alpha/mpo-list',
                        isActive: false,
                        description: ''
                    }
                ]
            },
            {
                id: 'INVOICE',
                title: 'Payment & Due Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'USER_WISE_INVOICE_AND_DUE_REPORT,USER_WISE_INVOICE_AND_DUE_INCLUDING_IN_DELIVERY_REPORT',
                        title: 'Invoice and Due by User Report',
                        type: 'item',
                        url: '/due-report/invoice-and-due-by-user',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'CHEMIST_WISE_INVOICE_AND_DUE_REPORT,CHEMIST_WISE_INVOICE_AND_DUE_INCLUDING_IN_DELIVERY_REPORT',
                        title: 'Invoice and Due by Chemist Report',
                        type: 'item',
                        url: '/due-report/invoice-and-due-by-chemist',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'BANK_WISE_PAYMENT_COLLECTION_DMS',
                        title: 'Bank Wise Payment Collection List',
                        type: 'item',
                        url: '/payment-collection/bank-wise-collection-list',
                        isActive: false,
                    },
                ]
            },
            {
                id: 'INVOICE',
                title: 'Sales Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'PRODUCT_WISE_SALES_SUMMARY_REPORT_DMS',
                        title: 'Product Wise Sales Summary',
                        type: 'item',
                        url: '/sales-report/product-wise-sales-summary',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'CHEMIST_PRODUCT_WISE_SALES_QUANTITY_DMS',
                        title: 'Chemist Product Wise Sales Summary',
                        type: 'item',
                        url: '/sales-report/chemist-product-wise-sales-quantity',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'USER_S_PRODUCT_WISE_SALES_QUANTITY_DMS',
                        title: 'User Product Wise Sales Quantity',
                        type: 'item',
                        url: '/sales-report/users-product-wise-sales-quantity',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'PARTY_WISE_SALES_REPORT',
                        title: 'Party Wise Sales',
                        type: 'item',
                        url: '/sales-report/party-wise-sales',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'MARKET_AND_USER_WISE_SALES_REPORT',
                        title: 'Market & User Wise Sales',
                        type: 'item',
                        url: '/sales-report/market-user-wise-sales',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'INVOICE_SALES_REPORT_ON_TP',
                        title: 'Invoice Sales Report on TP',
                        type: 'item',
                        url: '/report-invoice/sales-report-on-tp',
                        isActive: false
                    },
                    {
                        id: 'INVOICE_SALES_REPORT_ON_TP_PLUS_VAT',
                        title: 'Invoice Sales Report on TP + Vat',
                        type: 'item',
                        url: '/report-invoice/sales-report-on-tp-plus-vat',
                        isActive: false
                    },
                    {
                        id: 'INVOICE_SALES_REPORT_ON_TP_COMPARE',
                        title: 'Invoice Sales Report on TP Compare',
                        type: 'item',
                        url: '/report-invoice/sales-report-on-tp-compare',
                        isActive: false
                    },
                    {
                        id: 'USER_PRODUCT_WISE_SALES_REPORT',
                        title: 'Invoice User Product Wise Sales',
                        type: 'item',
                        url: '/report-invoice/user-product-wise-sales',
                        isActive: false
                    },
                    {
                        id: 'USER_PRODUCT_WISE_SALES_COMPARE_REPORT',
                        title: 'Invoice User Product Wise Sales Compare',
                        type: 'item',
                        url: '/report-invoice/user-product-wise-sales-compare',
                        isActive: false
                    },
                    {
                        id: 'PRODUCT_MARKET_LEVEL_WISE_SALES_SUMMARY_REPORT',
                        title: 'Product and Market Level Wise Sales Summary',
                        type: 'item',
                        url: '/report-invoice/product-and-market-level-wise-sales-summary',
                        isActive: false
                    },
                    {
                        id: 'MARKET_PRODUCT_LINE_WISE_SALES_REPORT',
                        title: 'Market and Product Line wise Sales Report',
                        type: 'item',
                        url: '/report-invoice/market-and-product-line-wise-sales-report',
                        isActive: false
                    }
                ]
            },
            {
                id: 'chemist_report',
                title: 'Chemist',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'VIEW_CHEMIST_LEDGER',
                        title: 'Chemist Ledger Report',
                        type: 'item',
                        url: '/chemist-ledger/list',
                        isActive: false,
                        description: ''
                    }
                ]
            },
            {
                id: 'depot_report',
                title: 'Stock Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                description: '',
                children: [
                    {
                        id: 'VIEW_DEPOT_STOCK_TRANSACTION',
                        title: 'Depot Stock Transaction Report',
                        type: 'item',
                        url: '/report-depot-stock/stock-transaction-report',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'VIEW_DEPOT_STOCK',
                        title: 'All Depot Stock',
                        type: 'item',
                        url: '/report-depot-stock/all-depot-stock',
                        isActive: false,
                        description: ''
                    },
                    {
                        id: 'DEPOT_STOCK_MOVEMENT_REPORT',
                        title: 'Depot Stock Movement Report',
                        type: 'item',
                        url: '/report-depot-stock/stock-movement-report',
                        isActive: false,
                        description: ''
                    }
                ]
            }

        ]
    },
    {
        id: 'superadmin',
        title: 'Administration',
        translate: 'NAV.SUPERADMIN',
        type: 'group',
        icon: 'bar_chart',
        isActive: false,
        children: [
            // {
            //     id: 'super_admin_menu',
            //     title: 'Dashboard',
            //     translate: 'NAV.DASHBOARDS',
            //     type: 'item',
            //     icon: 'home',
            //     url: '/dashboard',
            //     isActive: false
            // },
            {
                id: 'organization_super_admin',
                title: 'Organization',
                translate: 'NAV.ORGANIZATION',
                type: 'collapsable',
                icon: 'business',
                isActive: false,
                url: '/organization/list'
            },
            {
                id: 'market_for_super_admin',
                title: 'Market Level',
                translate: 'NAV.MARKET_LEVEL',
                type: 'collapsable',
                icon: 'business_center',
                isActive: false,
                url: '/market-level/list'
            },
            {
                id: 'payment_approval_rule',
                title: 'Payment Approval Rules',
                translate: 'NAV.PAYMENT_APPROVAL',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                url: '/paymentApproveRule/list'
            },
            {
                id: 'bill_pending_organization',
                title: 'Bill Pending Organization',
                translate: 'NAV.DASHBOARDS',
                type: 'item',
                icon: 'home',
                url: '/bill-pending-organization/list',
                isActive: false
            },
            {
                id: 'expense_claim_approval_rule',
                title: 'Expense Claim Approval Rules',
                translate: 'NAV.EXPENSE_CLAIM_APPROVAL',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                url: '/expenseclaimApproveRules/list'
            },
            {
                id: 'ta_da_claim_approval_rule',
                title: 'TA DA Claim Approval Rules',
                translate: 'NAV.EXPENSE_CLAIM_APPROVAL',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                url: '/ta-da-claim-approval/list'
            },
            {
                id: 'chemist_approval_rule',
                title: 'Chemist Approval Rules',
                translate: 'NAV.CUSTOMER_APPROVAL',
                type: 'collapsable',
                icon: 'local_pharmacy',
                isActive: false,
                url: '/customerApproveRules/list'
            },
            {
                id: 'tour_plan_approval_rule',
                title: 'Tour Plan Approval Rules',
                translate: 'NAV.TOURPLAN_APPROVAL',
                type: 'collapsable',
                icon: 'event',
                isActive: false,
                url: '/tourplanApproveRules/list'
            },
            {
                id: 'doctor_approval_rule',
                title: 'Doctor Approval Rules',
                translate: 'NAV.DOCTOR_LEAVE_APPROVAL',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                url: '/doctor-approval-rules/list'
            },
            {
                id: 'visit_approval_rule',
                title: 'Visit Approval Rules',
                translate: 'NAV.VISIT_APPROVAL',
                type: 'collapsable',
                icon: 'event_note',
                isActive: false,
                url: '/visitApproveRules/list'
            },
            // {
            //     id: 'super_admin_menu',
            //     title: 'Doctor Survey Approval Rules',
            //     translate: 'NAV.USER_LEAVE_APPROVAL',
            //     icon: 'event_note',
            //     type: 'collapsable',
            //     url: '/surveyDoctorApproveRules/list',
            //     isActive: false
            // },
            // {
            //     id: 'super_admin_menu',
            //     title: 'Employee Survey Approval Rules',
            //     translate: 'NAV.USER_LEAVE_APPROVAL',
            //     icon: 'event_note',
            //     type: 'collapsable',
            //     url: '/employeeApproveRules/list',
            //     isActive: false
            // },
            // {
            //     id: 'super_admin_menu',
            //     title: 'Site Survey Approval Rules',
            //     translate: 'NAV.USER_LEAVE_APPROVAL',
            //     icon: 'event_note',
            //     type: 'collapsable',
            //     url: '/surveySiteApproveRules/list',
            //     isActive: false
            // },
            // {
            //     id: 'super_admin_menu',
            //     title: 'Chemist Survey Approval Rules',
            //     translate: 'NAV.USER_LEAVE_APPROVAL',
            //     icon: 'event_note',
            //     type: 'collapsable',
            //     url: '/surveyChemistApproveRules/list',
            //     isActive: false
            // },
            {
                id: 'user_leave_approval_rule',
                title: 'User Leave Approve Rules',
                translate: 'NAV.USER_LEAVE_APPROVAL',
                type: 'collapsable',
                icon: 'local_hotel',
                isActive: false,
                url: '/userleaveApproveRules/list',
            },
            {
                id: 'order_approve_rule',
                title: 'Order Approval Rules',
                translate: 'NAV.ORDER_APPROVAL',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                url: '/orderApproveRules/list',
            },

            {
                id: 'user_role_super_admin',
                title: 'User Role',
                translate: 'NAV.USER_ROLE',
                type: 'collapsable',
                icon: 'supervisor_account',
                isActive: false,
                url: '/user-role/list',
            }
        ]
    }
];
